import styled, { keyframes } from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import { palette, variant } from '../../utils/theme.es.js';
import { Card } from '../Card/Card.es.js';
import { Shelf } from '../../primitives/Shelf/Shelf.es.js';
import { Group } from '../../primitives/Group/Group.es.js';

const TRANSITION_DURATION = 500;
const openAnimation = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`;
const closeAnimation = keyframes`
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
`;
const FeatureCard = styled(Card)`
    background-color: ${({ backgroundColor }) => backgroundColor};
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
`;
const FeatureCardContent = styled(Card.Content)`
    height: 100%;
`;
const featureCardShapeStyles = variant({
  prop: "shape",
  variants: {
    square: {
      "&:before": {
        paddingTop: "100%"
      }
    },
    rectangle: {
      "&:before": {
        paddingTop: "49.67%",
        minHeight: "150px"
      }
    }
  }
});
const FeatureCardWrapper = styled(Box)`
    position: relative;
    width: 100%;
    overflow: hidden;

    &:before {
        content: '';
        display: block;
    }

    ${featureCardShapeStyles};
    ${FeatureCard} {
        background-image: url(${({ backgroundImage }) => backgroundImage});
        background-size: cover;
        background-position: 50% 50%;
    }
`;
const FeatureCardMedia = styled(Box)`
    background-color: ${palette("neutral.900")};
    box-shadow: 0 2px 4px 0 rgba(20, 39, 57, 0.24);
`;
const FeatureCardShelf = styled(Shelf)`
    height: 100%;
`;
const FeatureCardGroup = styled(Group)`
    &.entering {
        animation: ${openAnimation} ${TRANSITION_DURATION}ms ease both;
    }

    &.exiting {
        animation: ${closeAnimation} ${TRANSITION_DURATION}ms ease both;
    }
`;

export { FeatureCard, FeatureCardContent, FeatureCardGroup, FeatureCardMedia, FeatureCardShelf, FeatureCardWrapper, TRANSITION_DURATION };
//# sourceMappingURL=styled.es.js.map
